import { render, staticRenderFns } from "./ProductOptionsForm.vue?vue&type=template&id=45accdcc&scoped=true&"
import script from "./ProductOptionsForm.vue?vue&type=script&lang=js&"
export * from "./ProductOptionsForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductOptionsForm.vue?vue&type=style&index=0&id=45accdcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45accdcc",
  null
  
)

export default component.exports